import { sortItems } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

import { useLocalizedLifeAreas } from './use-localized-life-areas';

export type Options = {
  activeOnly?: boolean;
};

export const useSortedLocalizedLifeAreas = ({ activeOnly }: Options = {}) => {
  const user = useUser();
  const lifeAreas = useLocalizedLifeAreas({ activeOnly });

  return useMemo(
    () => sortItems(lifeAreas, user?.settings?.lifeAreaSorting ?? [], 'id'),
    [lifeAreas, user?.settings?.lifeAreaSorting],
  );
};
